import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import { InputField } from "../../components";
export default function ChangePasswordModal({
  handleModal,
  isLoading,
  selectedUser,
  fetchUsersListing,
}) {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validateForm = (field = null) => {
    const newErrors = { ...errors };
    const { newPassword, confirmPassword } = formData;

    // Only validate specific field or all fields if none specified
    const validateAll = !field;

    if (validateAll || field === "newPassword") {
      if (!newPassword.trim()) {
        newErrors.newPassword = "New password is required";
      } else if (newPassword.length < 8) {
        newErrors.newPassword = "Password must be at least 8 characters long";
      } else {
        delete newErrors.newPassword;
      }
    }

    if (validateAll || field === "confirmPassword") {
      if (!confirmPassword) {
        newErrors.confirmPassword = "Please confirm your password";
      } else if (newPassword !== confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      } else {
        delete newErrors.confirmPassword;
      }
    }

    // Only update state if there are changes
    if (JSON.stringify(errors) !== JSON.stringify(newErrors)) {
      setErrors(newErrors);
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    const isValid = validateForm();
    if (!isValid) return;

    try {
      const response = await api.post("/api/users/change_password", {
        user_id: selectedUser?.id,
        password: formData.newPassword,
      });

      if (response.status === 200) {
        toast.success("Password changed successfully");
        handleModal();
        fetchUsersListing();
      }
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error(error.response?.data?.message || "Failed to change password");
    }
  };

  // Validate field on blur
  const handleBlur = (field) => {
    validateForm(field);
  };

  return (
    <div className="space-y-4">
      <div>
        <InputField
          label="New Password"
          name="newPassword"
          placeholder="Enter new password"
          type="password"
          value={formData.newPassword}
          onBlur={() => submitted && handleBlur("newPassword")}
          onChange={(e) => {
            const value = e.target.value;
            setFormData((prev) => ({
              ...prev,
              newPassword: value,
            }));
            // Only validate while typing if form has been submitted
            if (submitted) {
              if (errors.newPassword) {
                validateForm("newPassword");
              }
              // If there's a confirm password, validate it against the new password
              if (formData.confirmPassword) {
                validateForm("confirmPassword");
              }
            }
          }}
          error={submitted ? errors.newPassword : ""}
          required
          autoComplete="new-password"
        />
      </div>
      <div>
        <InputField
          label="Confirm Password"
          name="confirmPassword"
          placeholder="Enter confirm password"
          type="password"
          value={formData.confirmPassword}
          onBlur={() => submitted && handleBlur("confirmPassword")}
          onChange={(e) => {
            const value = e.target.value;
            setFormData((prev) => ({
              ...prev,
              confirmPassword: value,
            }));
            // Only validate while typing if form has been submitted
            if (submitted && errors.confirmPassword) {
              validateForm("confirmPassword");
            }
          }}
          error={submitted ? errors.confirmPassword : ""}
          required
          autoComplete="new-password"
        />
      </div>
      <div className="flex items-cente justify-end mt-5 space-x-2 text-white">
        <button
          onClick={() => handleModal()}
          type="button"
          className="btnPrimary bg-red-500"
        >
          Cancel
        </button>

        {isLoading ? (
          <div className="bg-blue/10 flex items-center justify-center rounded-md py-2 w-48">
            <img src="/img/loading.gif" className="w-7" alt="" />
          </div>
        ) : (
          <button
            type="button"
            onClick={handleSubmit}
            className="btnPrimary bg-green-600"
          >
            {isLoading ? "Updating..." : "Update Password"}
          </button>
        )}
      </div>
    </div>
  );
}
